export default {
    /**
     * custom config - this is set up by etranzact developers
     */
    defaultPath: "/login",
    basename: "/cpay", // only at build time to set, like /datta-able
    /**  baseURL: process.env.REACT_APP_BASE_URL,
   
    webSocketBaseURL: `${process.env.REACT_APP_BASE_URL}/ws`,
    httpTimeout: process.env.REACT_APP_HTTP_REQUEST_TIMEOUT, // 2 minutes */
    
    baseURL: " https://corporatepay.etranzactng.net/core",
    webSocketBaseURL: " https://corporatepay.etranzactng.net/core/ws",

    httpTimeout: process.env.REACT_APP_HTTP_REQUEST_TIMEOUT, // 2 minutes
    clearLoginDetailsTimeout: 1000 * 60 * 10, // 3 minutes
    sessionTimeout: 1000 * 60 * 15, //  15minutes
    numberOfLoginAttempt: 4,
    isSessionStorage: true, //   True: sessionStorage; false: localStorage
    /**
     * Template config  - came with the template,use inside appReducer
     */
    layout: "vertical", // vertical, horizontal
    preLayout: "", // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
    collapseMenu: false, // mini-menu, false
    layoutType: "menu-dark", // menu-dark, menu-light, dark
    navIconColor: false,
    headerBackColor: "header-default", // header-cpay, header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
    navBackColor: "navbar-default", // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
    navBrandColor: "brand-default", // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
    navBackImage: false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
    /**
     * style1 =  icon-chevron-right
     * style2 =  icon-chevrons-right "double arrow icon"
     */
    navDropdownIcon: "style1", // style1, style2, style3
    navListIcon: "style1", // style1, style2, style3, style4, style5, style6
    navActiveListColor: "active-default", // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
    navListTitleColor: "title-default", // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
    navListTitleHide: false,
    configBlock: true, // this control the configuration setting at the right hand side for theme color
    layout6Background: "linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)", // used only for pre-layout = layout-6
    layout6BackSize: "" // used only for pre-layout = layout-6
};